<template>
    <CRow>
        <CCol col="12" lg="12">
            <CCard>
                <CCardBody>
                    <form
                        @submit.prevent="createRecord('REQUESTS', {category_id:category_id})"
                        method="post"
                    >
                        <h3 v-if="isEditing">
                            {{ $t('button.edit') }} {{ $t('requests.title') }}
                        </h3>
                        <h3 v-else>{{ $t('button.create') }} {{ $t('requests.title') }}</h3>
                        <br>
                        <CRow>
                            <CCol col="12" lg="12">
                                <CSelect 
                                    :placeholder="$t('categories.placeholder')" 
                                    :label="$t('categories.title')" 
                                    :options="categories"
                                    :value.sync="category_id"
                                    :plain="true"
                                ></CSelect>
                            </CCol>
                       </CRow>
                        <CRow>
                            <CCol col="12" lg="12" class="text-right">
                                <CButton color="success" type="submit" class="m-2">
                                    <template v-if="isEditing">
                                        <CIcon :content="updateIcon" /> {{ $t('button.update') }}
                                    </template>
                                    <template v-else>
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }}
                                    </template>
                                </CButton>
                            </CCol>
                        </CRow>
                    </form>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'CategoryCreate',
    mixins: [catalog],
    data() {
        return {
            updateIcon: cilSync,
            addIcon: cilPlus,
            backIcon: cilArrowLeft,
            category_id: null,
            categories: [],
        }
    },
    async mounted() {
        let self = this;

        axios.get(`categories`)
            .then(response => {
                response.data.forEach(function(record){
                    self.categories.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
